import { useState } from 'react';
import I18n from 'I18n';
import { SidebarCollapseIcon } from 'foundations-assets/icons/components/SidebarCollapseIcon';
import { SidebarExpandIcon } from 'foundations-assets/icons/components/SidebarExpandIcon';
import { CollapsiblePanelHeader } from './CollapsiblePanelHeader';
import { PanelWrapper, ContentWrapper, RotatedIcon } from './CollapsiblePanelStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SidebarPanel({
  borderSide,
  iconRotated,
  expandAriaLabel,
  collapseAriaLabel,
  expandTooltip,
  collapseTooltip,
  title,
  children,
  'data-test-id': dataTestId
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const resolvedExpandTooltip = expandTooltip !== null && expandTooltip !== void 0 ? expandTooltip : I18n.text('customer-portal-app.panel.expandTooltip');
  const resolvedCollapseTooltip = collapseTooltip !== null && collapseTooltip !== void 0 ? collapseTooltip : I18n.text('customer-portal-app.panel.collapseTooltip');
  const icon = isCollapsed ? /*#__PURE__*/_jsx(SidebarExpandIcon, {
    color: "icon-core-default",
    size: "800"
  }) : /*#__PURE__*/_jsx(SidebarCollapseIcon, {
    color: "icon-core-default",
    size: "800"
  });
  return /*#__PURE__*/_jsxs(PanelWrapper, {
    $isCollapsed: isCollapsed,
    $borderSide: borderSide,
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/_jsx(CollapsiblePanelHeader, {
      isCollapsed: isCollapsed,
      onToggle: () => setIsCollapsed(!isCollapsed),
      tooltip: isCollapsed ? resolvedExpandTooltip : resolvedCollapseTooltip,
      ariaLabel: isCollapsed ? expandAriaLabel : collapseAriaLabel,
      icon: iconRotated ? /*#__PURE__*/_jsx(RotatedIcon, {
        children: icon
      }) : icon,
      title: title
    }), /*#__PURE__*/_jsx(ContentWrapper, {
      $isCollapsed: isCollapsed,
      children: !isCollapsed && children
    })]
  });
}